
// hero social links home three

import { Link } from "react-router-dom";

const hero_link_home_three = [
  {
    id: 1,
    link: "https://www.facebook.com/doaguruinfosystems/",
    title: "Facebook",
  },
  {
    id: 2,
    link: "https://www.linkedin.com/company/doaguru-infosystem/",
    title: "Linkedin",
  },
  {
    id: 3,
    link: "https://www.instagram.com/doaguru_infosystem/",
    title: "Instagram",
  },
  {
    id: 4,
    link: "https://x.com/DoaguruS",
    title: "Twitter",
  },
  {
    id: 4,
    link: "https://www.youtube.com/@doaguru4230",
    title: "YouTube",
  }
]
export const SocialLinks = () => {
  return (
    <>
      {hero_link_home_three.map((h_item, h_index) => (
        <Link
          key={h_index}
          to={h_item.link}
          className="cs_center"
          target="_blank">
          {h_item.title}
        </Link>
      ))}
    </>
  )

}


// copy right text 


const copy_right_text = {
  copy_right: <>
    Copyright © {new Date().getFullYear()}, DOAGuru InfoSystems All Right reserved
  </>
}

const { copy_right } = copy_right_text
export const CopyRight = () => {
  return (
    <> {copy_right}</>
  )
}


